export default __webpack_public_path__ + "static/media/location-2.b17104f1.webp";